import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url

const TRAE_URL = `${API_URL}/indemnizacion/`

export async function getUrlAlcantara() {
    return await axios({
      method: "GET",
      url: `${TRAE_URL}`,
    })
      .then((response) => response.data)
      .catch((response) => (response.data = "Error"));
  }